import React from "react";
import "./styles.css";
import CompletedBadge from "../CompletedBadge";

export interface CircularButtonProps {
  icon: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  /** When true, shows loadingLabel instead of label and disables the button */
  isLoading?: boolean;
  loadingLabel?: string;
  /** Shows a completed checkmark badge on the icon circle */
  isCompleted?: boolean;
  /** default = white gradient border | danger = coral gradient border (e.g. end session) */
  variant?: "default" | "danger";
}

const CircularButton: React.FC<CircularButtonProps> = ({
  icon,
  label,
  onClick,
  disabled = false,
  isLoading = false,
  loadingLabel,
  isCompleted = false,
  variant = "default",
}) => {
  const displayLabel = isLoading && loadingLabel ? loadingLabel : label;

  return (
    <button
      className={`circular-btn circular-btn--${variant}`}
      onClick={onClick}
      disabled={disabled || isLoading}
      aria-label={displayLabel}
    >
      <div className="circular-btn__circle">
        <img src={icon} alt="" className="circular-btn__icon" />
        {isCompleted && <CompletedBadge className="circular-btn__badge" />}
      </div>
      <span className="circular-btn__label">{displayLabel}</span>
    </button>
  );
};

export default CircularButton;
